"use client";

import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ZonaPPProfilHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = [{
    label: "MANDAT",
    value: "SAH"
  }, {
    label: "KOMANDO",
    value: "TEGAS"
  }, {
    label: "WILAYAH",
    value: "NASIONAL"
  }];
  return <section data-section-id="3626" id="zonappprofilhero" className="bg-white text-black relative min-h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pp_hero_banner.webp)]" />
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(0, 0%, 0%, 0.4) 0%, hsla(0, 0%, 0%, 0.85) 70%, hsla(0, 0%, 0%, 0.95) 100%)"
    }} />
      <div className="absolute inset-0 bg-white/10" />

      {}
      <div className="absolute inset-0 mix-blend-overlay opacity-30" style={{
      background: "radial-gradient(circle at 30% 40%, hsla(25, 83%, 55%, 0.3) 0%, transparent 50%)"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-gray-200" />

      {}
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1600px] flex-col px-6 pt-24 pb-32 sm:px-10 lg:px-16">
        <div className="grid flex-1 grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={headlineRef} className={`lg:col-span-9 flex flex-col justify-center transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-orange-600" />
              <span className="font-sans text-xs uppercase tracking-[0.3em] text-gray-500">
                ZONA PEMUDA PANCASILA — ABADI.NEWS
              </span>
            </div>

            {}
            <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tight text-white">
              <span className="block text-[clamp(3.5rem,12vw,10rem)]">ZONA</span>
              <span className="block text-[clamp(3.5rem,12vw,10rem)] sm:pl-[8vw] lg:pl-[120px]">
                PANCASILA
              </span>
            </h1>

            {}
            <div className="my-10 h-[2px] w-20 bg-orange-600" />

            {}
            <p className="font-sans italic text-lg sm:text-xl text-gray-300 max-w-[520px] leading-relaxed">
              Menjaga marwah konstitusi, mengawal mandat organisasi, dan melayani masyarakat dengan semangat nasionalisme yang abadi.
            </p>

            {}
            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
              <Button asChild size="lg" className="group h-14 px-8 bg-orange-600 text-white font-default font-bold uppercase tracking-wider text-sm rounded-lg shadow-lg hover:bg-orange-700 transition-all duration-300">
                <Link to="/PancasilaYouthZonePage">
                  Jelajahi Zona PP
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="link" className="font-sans text-xs uppercase tracking-[0.25em] text-white hover:text-orange-500 h-14 px-2">
                <Link to="/ProfileConstitutionPage">Lihat Konstitusi →</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={metaRef} className={`hidden lg:col-span-3 lg:flex items-stretch justify-end transition-all duration-1000 delay-300 ease-out ${metaVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative flex items-center">
              <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-700" />
              <div className="font-sans text-xs uppercase text-gray-400 tracking-[0.2em] whitespace-nowrap pr-6" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                ABADI.NEWS / ZONA PP / MANDAT NASIONAL / 2024
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative z-10 mt-16 flex flex-col gap-8">
          {}
          <div className="flex items-center gap-3">
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-gray-400">
              Scroll
            </span>
            <ChevronDown className="size-4 text-orange-600 animate-bounce" />
          </div>

          {}
          <div className="h-px w-full bg-gray-700" />

          {}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4">
            {dataPoints.map((point, i) => <div data-index={i} key={point.label} className="flex items-baseline gap-4">
                <span className="font-sans text-xs uppercase tracking-[0.25em] text-gray-400">
                  {point.label}
                </span>
                <span className="font-default font-bold text-lg text-orange-500">
                  {point.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gray-200" />
    </section>;
}